import React, { useEffect, useState } from "react";
import axios from "axios";

import { NavLink, useNavigate } from "react-router-dom";

// images
import Logo from "../images/25.png";
import Coin from "../images/coin.gif";
import Gift from "../images/gift.gif";

// components
import "antd/dist/antd.css";
import {
  Button,
  Typography,
  Row,
  Col,
  Badge,
  Affix,
  message,
  Popconfirm,
  Spin,
  Divider,
} from "antd";

import moment from "moment";

import { LeftCircleOutlined, ShoppingOutlined } from "@ant-design/icons";

import { db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

const { Title } = Typography;

function Order() {
  const [cart, setCart] = useState(null);
  const [info, setInfo] = useState(null);
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [gift, setGift] = useState(null);
  const [idGoogleSheet, setIdGoogleSheet] = useState(null);

  let navigate = useNavigate();

  useEffect(() => {
    setLoading(true);

    checkStatusWeb();
    getData();
    getGifts();

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const checkStatusWeb = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "control_web"), where("isactive", "==", false))
    );

    const res = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
          moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
          moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (res.length !== 0) {
      navigate("/maintain");
    }
  };

  const getData = async () => {
    if (
      JSON.parse(localStorage.getItem("Cart")) &&
      JSON.parse(localStorage.getItem("Cart")).length !== 0
    ) {
      const querySnapshot = await getDocs(
        query(collection(db, "packages"), where("isactive", "==", true))
      );
      const allPack = querySnapshot.docs.map((doc) => doc.data());

      const cartPack = JSON.parse(localStorage.getItem("Cart")).filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
          moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
          moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss") &&
          x.isactive === true
      );

      // mapping สำหรับแพ็คเกจที่ไม่ได้อยู่ใน DB (hardcoded)
      const codeMap = {
        // ถ้ามีการใช้ 26Pro06 ให้ถือว่าเทียบเท่ากับ 26Pro01 ที่อยู่ใน DB
        "26Pro06": "26Pro01",
      };

      let arr = [];
      for (let i = 0; i < allPack.length; i++) {
        for (let j = 0; j < cartPack.length; j++) {
          const cartCode = cartPack[j].ecoupon_code;
          const normalizedCartCode = codeMap[cartCode] ? codeMap[cartCode] : cartCode;

          if (
            allPack[i].ecoupon_code === normalizedCartCode &&
            allPack[i].isactive === cartPack[j].isactive &&
            allPack[i].start_date === cartPack[j].start_date &&
            allPack[i].end_date === cartPack[j].end_date
          ) {
            // เก็บรายการจาก localStorage (ไม่เปลี่ยน ecoupon_code ที่ผู้ใช้เห็น)
            arr.push(cartPack[j]);
          }
        }
      }

      if (arr.length !== 0) {
        setInfo(JSON.parse(localStorage.getItem("Info")));
        setPosition(JSON.parse(localStorage.getItem("Position")));
        setCart(arr);
        localStorage.removeItem("Cart");
        localStorage.setItem("Cart", JSON.stringify(arr));
      } else {
        navigate("/");
      }
    } else {
      navigate("/");
    }
  };

  const getGifts = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "gift"), where("isactive", "==", true))
    );
    const gift = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
          moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
          moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (gift.length === 0) {
      setGift(null);
    } else {
      setGift(
        gift.sort((a, b) => {
          if (a.condition < b.condition) {
            return -1;
          }
        })
      );
    }
  };

  const confirmOrder = async () => {
    window.scrollTo(0, 0);

    let total = cart.reduce((accumulator, object) => {
      return accumulator + object.price_pro * object.qty;
    }, 0);

    if (total <= 0) {
      localStorage.removeItem("Cart");
      navigate("/");
    }
    else {

      let storage_cart = JSON.parse(localStorage.getItem("Cart"));

      let current_coupon = storage_cart.filter(
        (x) =>
          x.type === "normal" ||
          x.type === "special" ||
          x.type === "promotion_season" ||
          x.type === "promotion_normal" ||
          x.type === "flashsale" ||
          x.type === "group"
      );
      let event_coupon = storage_cart.filter(
        (x) => x.type === "event" || x.type === "option"
      );

      var flags = [],
        output = [],
        l = event_coupon.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[event_coupon[i].ecoupon_code]) continue;
        flags[event_coupon[i].ecoupon_code] = true;
        event_coupon[i]["qty"] = event_coupon.filter(
          (x) => x.ecoupon_code === event_coupon[i].ecoupon_code
        ).length;
        output.push(event_coupon[i]);
      }

      // Flow Order Cause //

      for (let i = 0; i < current_coupon.length; i++) {
        if (current_coupon[i].ecoupon_code === "HE021") {
          current_coupon[i].price_pro = 1000;
          current_coupon[i].qty = 2 * current_coupon[i].qty;
          output.push(current_coupon[i]);
        } else if (current_coupon[i].ecoupon_code === "VIT04") {
          current_coupon[i].price_pro = 0;

          output.push(current_coupon[i]);
          output.push({
            ecoupon_code: "VIT01",
            name: "IV Myer's Cocktail Package ครั้งที่ 1",
            qty: 1 * current_coupon[i].qty,
            price_pro: 1490,
          });
          output.push({
            ecoupon_code: "VIT02",
            name: "IV Myer's Cocktail Package ครั้งที่ 2",
            qty: 1 * current_coupon[i].qty,
            price_pro: 1490,
          });
          output.push({
            ecoupon_code: "VIT03",
            name: "IV Myer's Cocktail Package ครั้งที่ 3",
            qty: 1 * current_coupon[i].qty,
            price_pro: 1490,
          });
        } else if (current_coupon[i].ecoupon_code === "VA015") {
          current_coupon[i].price_pro = 5000;
          current_coupon[i].qty = 3 * current_coupon[i].qty;
          output.push(current_coupon[i]);
        } else if (current_coupon[i].ecoupon_code === "VA016") {
          current_coupon[i].price_pro = 4700;
          current_coupon[i].qty = 5 * current_coupon[i].qty;
          output.push(current_coupon[i]);
        } else if (current_coupon[i].type === "group") {
          const querySnapshot = await getDocs(
            query(
              collection(db, "packages"),
              where("isactive", "==", true),
              where("type", "==", "subGroup"),
              where("event", "==", current_coupon[i].ecoupon_code)
            )
          );
          const pcks = querySnapshot.docs.map((doc) => doc.data());

          for (let j = 0; j < pcks.length; j++) {
            pcks[j].qty = pcks[j].qty * current_coupon[i].qty;
            output.push(pcks[j]);
          }
        } else {
          output.push(current_coupon[i]);
        }
      }

      // Flow Order Cause //
      // console.log(JSON.parse(localStorage.getItem("Gift")));

      if (JSON.parse(localStorage.getItem("Gift")) && JSON.parse(localStorage.getItem("Gift")) !== null) {
        info.gift = JSON.parse(localStorage.getItem("Gift"));
      }
      else {
        info.gift = "ไม่ได้ของแถม";
      }

      // if (gift !== null) {
      //   for (let i = 0; i < gift.length; i++) {
      //     if (
      //       total >=
      //       gift.sort((a, b) => {
      //         if (a.condition > b.condition) {
      //           return -1;
      //         }
      //       })[i].condition
      //     ) {
      //       if (gift[i].name === "ตั๋ว Meet and greetตู่ ภพธร หรือ ไดร์เป่าผม") {
      //         if (JSON.parse(localStorage.getItem("Gift")) === 1) {
      //           info.gift = "ตั๋ว Meet and greet ตู่ ภพธร";
      //         } else if (JSON.parse(localStorage.getItem("Gift")) === 2) {
      //           info.gift = "ไดร์เป่าผม";
      //         }
      //       } else {
      //         info.gift = gift[i].name;
      //       }
      //       break;
      //     } else {
      //       info.gift = "ไม่ได้ของแถม";
      //     }
      //   }
      // } else {
      //   info.gift = "ไม่ได้ของแถม";
      // }

      info.packages = output;

      if (position !== null) {
        info.lat = position.lat;
        info.lng = position.lng;
      } else {
        info.lat = "";
        info.lng = "";
      }

      // console.log(info);

      const querySnapshot = await getDocs(
        query(collection(db, "googlesheet"), where("isactive", "==", true))
      );

      const idGoogleSheet = querySnapshot.docs.map((doc) => doc.data());

      info.idGoogleSheet = idGoogleSheet[0].id;

      var config = {
        method: "POST",
        url: "https://us-central1-bhh-healthexpo.cloudfunctions.net/app/api/insert",
        // url: "http://localhost:5001/bhh-healthexpo/us-central1/app/api/insert",

        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Credentials": "true",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
          "Access-Control-Allow-Origin": "*",
        },
        data: info,
      };

      setLoading2(true);

      try {
        let res = await axios(config);

        if (res.status === 200) {
          setLoading2(false);
          message.success("ทำรายการสั่งซื้อสำเร็จ");
          // localStorage.removeItem("Cart");
          localStorage.removeItem("Product");
          localStorage.removeItem("Gift");
          localStorage.removeItem("SandConnect");
          localStorage.removeItem("RefCode");
          localStorage.setItem("OrderNo", res.data.orderNo);

          navigate("/notify");
        } else {
          message.error("Sorry,Please try again.");
          setLoading2(false);
        }
      } catch (e) {
        message.error("Sorry,Please try again.");
        setLoading2(false);
      }
    }


  };

  const Loading = () => {
    return (
      <div className="center" style={{ marginTop: "44vh" }}>
        <img src={Gift} style={{ width: "20%" }} />
        <br /> <p>Loading...</p>
      </div>
    );
  };

  return (
    <div>
      <Spin
        tip={
          <>
            <img src={Coin} style={{ width: "20%" }} />
            <br />
            <p style={{ color: "black" }}>กำลังทำรายการสั่งซื้อ...</p>
          </>
        }
        spinning={loading2}
        indicator={null}
      >
        <Affix offsetTop={0}>
          <div
            style={{
              padding: "20px",
              background: "rgba(255,255,255,0.8)",
              lineHeight: "130%",
            }}
          >
            <>
              <Row>
                <Col style={{ textAlign: "left" }}>
                  <LeftCircleOutlined
                    style={{
                      fontSize: "20px",
                      marginTop: "10px",
                      marginRight: "20px",
                      color: "#1e366f",
                    }}
                    onClick={() => window.history.back()}
                  />
                </Col>
                <Col flex="auto" style={{ textAlign: "left" }}>
                  <span
                    style={{
                      color: "white",
                      fontSize: "20px",
                      paddingRight: "10px",
                    }}
                  >
                    <NavLink to="/">
                      {" "}
                      <b>
                        <span style={{ color: "#1e366f", fontSize: "16px" }}>
                          {/* <img src={Logo} alt="" width={35} />  */} Bangkok
                          Hospital Hatyai <br />
                          <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                            Shopping World
                          </span>
                        </span>
                      </b>
                    </NavLink>
                  </span>
                </Col>
                <Col style={{ textAlign: "right" }}>
                  <NavLink to="/cart">
                    <Badge
                      count={
                        cart != null
                          ? cart.filter((x) => x.type !== "option").length
                          : null
                      }
                    >
                      <div
                        style={{ background: "white", borderRadius: "25px" }}
                      >
                        <ShoppingOutlined
                          style={{
                            color: "#1e366f",
                            fontSize: "28px",
                            padding: "7px",
                          }}
                        />
                      </div>
                    </Badge>
                  </NavLink>
                </Col>
              </Row>
            </>
          </div>
          <Divider style={{ margin: "0px" }} />
        </Affix>

        {loading ? (
          <Loading />
        ) : (
          <>
            <div style={{ minHeight: "80vh" }}>
              <Title
                level={5}
                style={{ textAlign: "left", padding: "20px 20px 10px 20px" }}
              >
                ข้อมูลลูกค้า
              </Title>
              <div
                style={{
                  padding: "20px 20px 5px 20px",
                  marginLeft: "10px",
                  marginRight: "10px",
                  borderRadius: "25px",
                  boxShadow: "1px 2px 10px silver",
                  background: "rgba(255, 255, 255, 1)",
                }}
              >
                {info !== null ? (
                  <>
                    <p>
                      ชื่อจริง-นามสกุล: {info.firstname} {info.lastname}
                    </p>
                    <p>วันเกิด: {moment(info.dob).format("YYYY/MM/DD")}</p>
                    {info.identification_number == 1 ? (
                      <p>บัตรประชาชน: {info.idcard}</p>
                    ) : (
                      <p>เลขที่หนังสือเดินทาง: {info.passport}</p>
                    )}
                    <p>อีเมลล์: {info.email}</p>
                    <p>เบอร์โทร: {info.tel}</p>
                  </>
                ) : null}
              </div>

              {cart != null && gift != null ? (
                cart.reduce((accumulator, object) => {
                  return accumulator + object.price_pro * object.qty;
                }, 0) >= gift[0].condition ? (
                  <>
                    <Title
                      level={5}
                      style={{
                        textAlign: "left",
                        padding: "20px 20px 10px 20px",
                      }}
                    >
                      ข้อมูลที่อยู่ (สำหรับจัดส่งของสัมนาคุณ)
                    </Title>
                    <div
                      style={{
                        padding: "20px 20px 5px 20px",
                        marginLeft: "10px",
                        marginRight: "10px",
                        borderRadius: "25px",
                        boxShadow: "1px 2px 10px silver",
                        background: "rgba(255, 255, 255, 1)",
                      }}
                    >
                      {info !== null ? (
                        <>
                          <Row>
                            <Col span={12}>
                              {" "}
                              {info.house_no !== undefined ? (
                                <p>บ้านเลขที่: {info.house_no}</p>
                              ) : null}
                            </Col>
                            <Col span={12}>
                              {" "}
                              {info.village_no !== undefined ? (
                                <p>หมู่ที่: {info.village_no}</p>
                              ) : null}
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              {" "}
                              {info.lane !== undefined ? (
                                <p>ซอย: {info.lane}</p>
                              ) : null}
                            </Col>
                            <Col span={12}>
                              {" "}
                              {info.road !== undefined ? (
                                <p>ถนน: {info.road}</p>
                              ) : null}
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              {" "}
                              {info.sub_district !== undefined ? (
                                <p>ตำบล: {info.sub_district}</p>
                              ) : null}
                            </Col>
                            <Col span={12}>
                              {" "}
                              {info.district !== undefined ? (
                                <p>อำเภอ: {info.district}</p>
                              ) : null}
                            </Col>
                          </Row>
                          <Row>
                            <Col span={12}>
                              {" "}
                              {info.province !== undefined ? (
                                <p>จังหวัด: {info.province}</p>
                              ) : null}
                            </Col>
                            <Col span={12}>
                              {" "}
                              {info.postal_code !== undefined ? (
                                <p>รหัสไปรษณีย์: {info.postal_code}</p>
                              ) : null}
                            </Col>
                          </Row>
                        </>
                      ) : null}
                    </div>
                  </>
                ) : null
              ) : null}

              {info !== null && info.tax_invoice === 1 ? (
                <>
                  <Title
                    level={5}
                    style={{
                      textAlign: "left",
                      padding: "20px 20px 10px 20px",
                    }}
                  >
                    ข้อมูลใบกำกับภาษี
                  </Title>
                  <div
                    style={{
                      padding: "20px 20px 5px 20px",
                      marginLeft: "10px",
                      marginRight: "10px",
                      borderRadius: "25px",
                      boxShadow: "1px 2px 10px silver",
                      background: "rgba(255, 255, 255, 1)",
                    }}
                  >
                    <Row>
                      <p>ชื่อบริษัท: {info.tax_company_name}</p>
                    </Row>
                    <Row>
                      <p>หมายเลขผู้เสียภาษี: {info.tax_payer_no}</p>
                    </Row>
                    <Row>
                      <Col span={12}>
                        <p>บ้านเลขที่: {info.tax_house_no}</p>
                        <p>ซอย: {info.tax_lane}</p>
                        <p>จังหวัด: {info.tax_province}</p>
                        <p>ตำบล: {info.tax_sub_district}</p>
                      </Col>
                      <Col span={12}>
                        <p>หมู่ที่: {info.tax_village_no}</p>
                        <p>ถนน: {info.tax_road}</p>
                        <p>อำเภอ: {info.tax_district}</p>
                        <p>รหัสไปรษณีย์: {info.tax_postal_code}</p>
                      </Col>
                    </Row>
                  </div>
                </>
              ) : null}

              <Title
                level={5}
                style={{ textAlign: "left", padding: "20px 20px 10px 20px" }}
              >
                รายการแพ็คเกจ
              </Title>
              <div
                style={{
                  padding: "20px 20px 5px 20px",
                  marginLeft: "10px",
                  marginRight: "10px",
                  borderRadius: "25px",
                  boxShadow: "1px 2px 10px silver",
                  background: "rgba(255, 255, 255, 1)",
                }}
              >
                {cart != null && cart.length != 0
                  ? cart.map((product) => {
                    return (
                      <>
                        <Row>
                          <Col span={16} style={{ textAlign: "left" }}>
                            <p>{product.name}</p>
                          </Col>
                          <Col span={6}>
                            <p>
                              ฿ {product.price_pro.toLocaleString("en-US")}
                            </p>
                          </Col>
                          <Col span={2}>
                            <p>x {product.qty}</p>
                          </Col>
                        </Row>
                      </>
                    );
                  })
                  : null}
              </div>

              {JSON.parse(localStorage.getItem("Gift")) !== null ? (
                <>
                  <Title
                    level={5}
                    style={{
                      textAlign: "left",
                      padding: "20px 20px 10px 20px",
                    }}
                  >
                    ของสมนาคุณ
                  </Title>
                  <div
                    style={{
                      padding: "20px 20px 5px 20px",
                      marginLeft: "10px",
                      marginRight: "10px",
                      borderRadius: "25px",
                      boxShadow: "1px 2px 10px silver",
                      background: "rgba(255, 255, 255, 1)",
                    }}
                  >
                    <p>{JSON.parse(localStorage.getItem("Gift"))}</p>
                  </div>
                </>
              ) : null}
            </div>

            <br />

            <Affix offsetBottom={0} style={{ fontSize: "16px" }}>
              <div
                style={{
                  backgroundColor: "white",
                  boxShadow: "0px 0px 10px #000000",
                }}
              >
                <Row>
                  <Col
                    // span={16}
                    flex="auto"
                    style={{ padding: "20px", textAlign: "right" }}
                  >
                    ยอดชำระเงินทั้งหมด
                    <br />
                    <span style={{ color: "#b21e2a" }}>
                      ฿{" "}
                      {cart != null
                        ? cart
                          .reduce((accumulator, object) => {
                            return (
                              accumulator + object.price_pro * object.qty
                            );
                          }, 0)
                          .toLocaleString("en-US")
                        : null}
                    </span>
                  </Col>
                  <Col
                    // span={8}
                    style={{ textAlign: "right" }}
                  >
                    <Popconfirm
                      placement="topRight"
                      title="คุณต้องการยืนยันคำสั่งซื้อนี้หรือไม่ ​?"
                      onConfirm={() => confirmOrder()}
                      okText="ใช่"
                      cancelText="ไม่"
                    >
                      <Button
                        type="primary"
                        style={{
                          width: "100%",
                          height: "100%",
                          background: "#1e366f",
                          border: 0,
                          fontSize: "16px",
                        }}
                      >
                        ยืนยันคำสั่งซื้อ
                      </Button>
                    </Popconfirm>
                  </Col>
                </Row>
              </div>
            </Affix>
          </>
        )}
      </Spin>
    </div>
  );
}

export default Order;
